import React from 'react';
import './givo.css';
import ReactDOM from 'react-dom/client';
import Givo from './Givo';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import ScrollTop from './component/Utility/ScrollTop';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <ScrollTop></ScrollTop>
    <Givo />
    </BrowserRouter>
  </React.StrictMode>
);
reportWebVitals();
